import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=15fa7f99"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=15fa7f99&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fa7f99')) {
      api.createRecord('15fa7f99', component.options)
    } else {
      api.reload('15fa7f99', component.options)
    }
    module.hot.accept("./TopNavbar.vue?vue&type=template&id=15fa7f99", function () {
      api.rerender('15fa7f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/horizontal/TopNavbar.vue"
export default component.exports